import { PublicClientApplication } from "@azure/msal-browser";
import { getAppConfig } from "./configService";

// Criar instância MSAL dinamicamente
export function createMsalInstance() {
  const cfg = getAppConfig();

  return new PublicClientApplication({
    auth: {
      clientId: cfg.CLIENT_ID,
      authority: cfg.AUTHORITY,
      redirectUri: cfg.REDIRECT_URI,
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: false,
    },
  });
}

// Criar login request dinamicamente
export function getLoginRequest() {
  const cfg = getAppConfig();

  return {
    scopes: [cfg.SCOPE1 || "", cfg.SCOPE2 || "", cfg.SCOPE3 || ""],
  };
}

// Criar token request dinamicamente
export function getTokenRequest() {
  const cfg = getAppConfig();

  return {
    scopes: [cfg.SCOPE3 || ""],
  };
}
